export default __webpack_public_path__ + "static/210519_魔獄塔更新熱更完成公告_jp-7c3cb601662d561176c68617bbd4b740.png";